import * as React from 'react';
import styled from 'styled-components';

const Video = styled.video`
    width: 100%;
`;

interface WebcamProps {
    mediaStream?: MediaStream;
    mediaBlob?: Blob;
    paused: boolean;
    muted: boolean;
}

class Webcam extends React.Component<WebcamProps> {
    public shouldComponentUpdate(nextProps: WebcamProps, state: any) {
        if (this.props.mediaStream && this.props.mediaStream === nextProps.mediaStream) {
            return false;
        } else {
            return true;
        }
    }

    public render() {
        return (
            <Video
                autoPlay={true}
                muted={this.props.muted}
                innerRef={(video: HTMLVideoElement) => {
                    if (video) {
                        if (this.props.mediaBlob) {
                            const blobSrc = URL.createObjectURL(this.props.mediaBlob);
                            video.src = blobSrc;
                            if (this.props.paused) {
                                setTimeout(() => video.pause(), 200);
                            }
                            if ('srcObject' in video) {
                                video.srcObject = null;
                            }
                        } else if (this.props.mediaStream) {
                            video.src = '';
                            if ('srcObject' in video) {
                                video.srcObject = this.props.mediaStream;
                            } else {
                                const src = URL.createObjectURL(this.props.mediaStream);
                                (video as HTMLVideoElement).src = src;
                            }
                        }
                    }
                }}
            />
        );
    }
}

export default Webcam;



// WEBPACK FOOTER //
// ./src/components/Webcam.tsx